import {i18n} from 'src/i18n';
//import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.tarea.fields.id'),
  },
];
